import builder from '../builder';
import Dislike2 from '../../streamline-icons/light/dislike-2.svg';

export default builder('IconDislike2Light', Dislike2);
